import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  deny: 'Ignore',
  notifications: 'Notifications',
  viewAll: 'View all notifications',
  noNotifications: 'No new notifications',
  markAsRead: 'Delete',
  viewCourse: 'View course',
  viewWorkspace: 'View workspace',
};

const welsh = {
  deny: 'Anwybyddu',
  notifications: 'Hysbysiadau',
  viewAll: 'Gweld pob',
  noNotifications: 'Dim hysbysiadau newydd',
  markAsRead: 'Dileu',
  viewCourse: 'Gweld y cwrs',
  viewWorkspace: 'Gweld y gweithle',
};

export const notificationsText: any = getLocalizationBasedOnLang(
  english,
  welsh,
);
